module.exports = __webpack_public_path__ + "img/limit_time.1594907a.png";